<template>
	<div class="right-list">
		<div class="section-title right-list-title" v-if="title">{{ title }}</div>
		<div class="right-list-item" v-for="(info, index) in infoList" :key="index">
			<div class="title">
				<span class="title-ol">0{{ index + 1 }}.</span>
				<span>{{ info.infoTitle }}</span>
			</div>
			<div class="content">
				<div class="content-l">
					<img :src="info.imgSrc" width="100%" height="100%" />
				</div>
				<div class="content-r">
					<p class="content-r-desc">{{ info.infoDesc }}</p>
					<div class="content-r-label" v-if="info.infoLabelList && info.infoLabelList.length">
						<p v-for="(item,index) in info.infoLabelList" :key="index">
							<span>{{ item }}</span>
						</p>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'rightList',
		props: {
			title: {
				type: String,
				default: '专属权益'
			},
			infoList: {
				type: Array,
				default: () => ({
				})
			},
		}
	};
</script>

<style lang="less" scoped>
	.right-list {
		padding: 0 14px;
		.right-list-title {
			margin: 30px 0  34px 0;
		}
		&-item {
			margin-bottom: 35px;
			.title {
				line-height: 16px;
				span{
					font-size:16px;
					font-family:PingFangSC-Medium,PingFang SC;
					font-weight:500;
					color: @darkBlack;
				}
				.title-ol {
					font-size:34px;
					font-family:DINCondensedBold;
					font-weight:bold;
					color:rgba(200,149,87,1);
					margin-right: 4px;
				}
			}
			.content {
				display: flex;
				margin-top: 24px;
				.content-l {
					width: 60px;
					height: 60px;
					margin: 0 16px 0 14px;
				}
				.content-r {
					flex: 1;
					.content-r-desc {
						font-size:12px;
						font-family:PingFangSC-Regular,PingFang SC;
						font-weight:400;
						color:rgba(153,153,153,1);
						line-height:20px;
					}
					.content-r-label {
						margin-top: 10px;
						display: flex;
						flex-direction: column;
						span {
							display: inline-block;
							box-sizing: content-box;
							margin-bottom: 5px;
							height: 12px;
							line-height: 12px;
							font-size:12px;
							padding: 5px 8px;
							background:rgba(249,244,238,1);
							border-radius:3px;
							font-family:PingFangSC-Regular,PingFang SC;
							font-weight:400;
							color:rgba(200,149,87,1);
						}
					}
				}
			}
		}
	}
</style>
